(() => {
  const DESKTOP_MQ = window.matchMedia("(min-width: 1024px)");
  const BIRSE_ROOT_SELECTOR = '[id*="__birse_visual_search_img_search"]';
  const SLOT_SELECTOR = "[data-birse-slot]";

  const state = {
    node: null,
    originalParent: null,
    originalNext: null,
    originalWrapper: null,
    mounted: false,
    observer: null,
    retryTimer: null,
    retryStart: 0,
  };

  function setReady() {
    document.documentElement.classList.add("is-birse-ready");
  }

  function clearReady() {
    document.documentElement.classList.remove("is-birse-ready");
  }

  function findSlot() {
    return document.querySelector(SLOT_SELECTOR);
  }

  function findBirseRoot() {
    return document.querySelector(BIRSE_ROOT_SELECTOR);
  }

  function stopObserver() {
    if (!state.observer) return;
    state.observer.disconnect();
    state.observer = null;
  }

  function stopRetry() {
    if (!state.retryTimer) return;
    window.clearInterval(state.retryTimer);
    state.retryTimer = null;
    state.retryStart = 0;
  }

  function rememberOriginalPosition(node) {
    if (state.node) return;

    state.node = node;
    state.originalParent = node.parentNode;
    state.originalNext = node.nextSibling;

    state.originalWrapper = node.parentElement;
    if (state.originalWrapper) {
      state.originalWrapper.setAttribute("data-birse-original-wrap", "true");
    }
  }

  function mount() {
    if (!DESKTOP_MQ.matches) return false;

    const slot = findSlot();
    const birse = findBirseRoot();
    if (!slot) return false; // slot이 없으면 아직 헤더가 준비 안 됨
    if (!birse) {
      // Birse가 아직 로드 안 되었더라도 pill 자체는 준비 상태로 풀어준다
      setReady();
      return true;
    }

    if (slot.contains(birse)) {
      state.mounted = true;
      birse.classList.add("is-birse-mounted");
      setReady();
      return true;
    }

    rememberOriginalPosition(birse);

    slot.appendChild(birse);
    birse.classList.add("is-birse-mounted");
    state.mounted = true;

    if (state.originalWrapper) {
      state.originalWrapper.classList.add("is-birse-moved");
    }

    setReady();
    return true;
  }

  function restore() {
    const birse = state.node || findBirseRoot();

    if (state.mounted && state.node && state.originalParent) {
      if (state.originalNext && state.originalParent.contains(state.originalNext)) {
        state.originalParent.insertBefore(state.node, state.originalNext);
      } else {
        state.originalParent.appendChild(state.node);
      }
    }

    if (birse) {
      birse.classList.remove("is-birse-mounted");
    }

    state.mounted = false;

    if (state.originalWrapper) {
      state.originalWrapper.classList.remove("is-birse-moved");
    }
  }

  function sync() {
    if (DESKTOP_MQ.matches) {
      mount();
    } else {
      // 모바일은 기존 위치/기존 UX 유지
      restore();
      setReady(); // 모바일에서도 잠금은 풀어줌(불필요한 transition lock 방지)
    }
  }

  function startRetryWindow() {
    stopRetry();
    state.retryStart = Date.now();

    // 2초 동안 80ms 간격으로 빠르게 재시도 (체감 중간상태 최소화)
    state.retryTimer = window.setInterval(() => {
      const done = mount();
      if (done) {
        stopRetry();
        stopObserver();
        return;
      }
      if (Date.now() - state.retryStart > 2000) {
        // 2초 후에는 강제 ready로 풀고 종료 (유저 체감 우선)
        setReady();
        stopRetry();
        stopObserver();
      }
    }, 80);
  }

  function observeUntilReady() {
    stopObserver();

    // slot/birse가 이미 있으면 바로 동기화
    if (findSlot()) {
      sync();
      // birse가 늦게 뜰 수 있으니 짧게 retry
      startRetryWindow();
      return;
    }

    // slot이 아직 없으면 DOM 변화 관찰
    state.observer = new MutationObserver(() => {
      if (findSlot()) {
        sync();
        startRetryWindow();
      }
    });

    state.observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    // 너무 오래 관찰하지 않기
    window.setTimeout(() => {
      setReady();
      stopObserver();
    }, 2500);
  }

  function resetState() {
    stopObserver();
    stopRetry();

    state.node = null;
    state.originalParent = null;
    state.originalNext = null;
    state.originalWrapper = null;
    state.mounted = false;

    // 전환 순간의 흔들림을 줄이기 위해 잠깐 lock
    clearReady();
  }

  function boot() {
    resetState();
    observeUntilReady();
  }

  // 초기 실행: defer 스크립트라면 가능한 빨리 호출
  boot();

  // 브레이크포인트 변경 대응
  DESKTOP_MQ.addEventListener?.("change", () => {
    boot();
  });

  // Shopify 테마 에디터 섹션 재로드 대응
  document.addEventListener("shopify:section:load", () => {
    boot();
  });

  // BFCache/뒤로가기 복원 대응
  window.addEventListener("pageshow", () => {
    boot();
  });

  // 일부 테마/앱에서 사용하는 전환 이벤트 대응(존재해도 문제 없음)
  document.addEventListener("turbo:load", () => {
    boot();
  });
})();
